import {computed, inject, type ComputedRef, type InjectionKey} from 'vue'

export type DropdownAvailableSpace = {
  availableHeight: number | null
  availableWidth: number | null
}

export const dropdownAvailableSpaceKey: InjectionKey<ComputedRef<DropdownAvailableSpace>> = Symbol('dropdownAvailableSpace')

const emptySpace = computed<DropdownAvailableSpace>(() => ({
  availableHeight: null,
  availableWidth: null,
}))

export function useDropdownAvailableSpace(): ComputedRef<DropdownAvailableSpace> {
  return inject(dropdownAvailableSpaceKey, emptySpace)
}
